<template>
  <div
    class="quotation-body print-body"
    id="printTest"
    :class="{ 'desk-page': this.device === 'desktop' && !isPdf, 'pdf': isPdf }"
    v-if="data">
    <!--loading-->
    <loading :complete="complete"></loading>
    <!--头部-->
    <tk-flex
      class="header no-print"
      between
      :class="{
        'header-mobile': this.device === 'mobile',
        'header-pc': this.device === 'desktop'
      }"
    >
      <tk-flex class="logo full-height" middle>
        <tk-image
          height="26"
          :replacement="false"
          src="http://moke-store.oss-cn-beijing.aliyuncs.com/a113431e-9efd-47c5-9168-1596a1a7901c.png"
        />
      </tk-flex>
      <div class="fill"></div>
      <div
        class="pointer-btn"
        v-if="this.device === 'desktop'"
        @click="printPlan"
      >
        <tk-icon :color="'#999999'" :size="32" material>print</tk-icon>
      </div>
      <div
        class="pointer-btn m-l-15"
        v-if="this.device === 'desktop'"
        @click="exportPdf"
      >
        <tk-icon :color="'#999999'" :size="32" material>get_app</tk-icon>
      </div>
    </tk-flex>
    <tk-flex center column class="title-page">
      <div class="title body-title">{{data.title ? data.title : '' }}</div>
      <div class="author">
        <div>策划：默客科技</div>
        <div class="body-date">时间：{{data.updated_at | date}}</div>
      </div>
    </tk-flex>
    <div class="modules">
      <div class="module-box" v-for="(module) in data.modules">
        <div class="block-title title-td">{{module.title ? module.title : ''}}</div>
        <table cellspacing="0" cellpadding="0">
          <tr class="td-tr-title">
            <th>功能模块</th>
            <th>功能描述</th>
          </tr>
          <tr v-for="item in module.data">
            <td>{{item.name}}</td>
            <td>{{item.detail}}</td>
          </tr>
        </table>
      </div>
    </div>
    <!--产品建议模块-->
    <tk-flex
      center column class="suggest p-b-30 no-print"
      v-if="data.suggest && data.suggest.length"
    >
      <div class="block-title">产品建议</div>
      <div
        class="suggest-item"
        v-for="(s, index) in data.suggest"
        :key="`suggest-item${index}`"
        :class="{ 'm-t-20': index === 0 }"
      >
        <div class="suggest-name">{{s.name}}</div>
        <div
          class="item-radius"
        >
          <div class="suggest-detail">{{s.detail}}</div>
          <div class="suggest-body font-14">{{s.suggest}}</div>
          <tk-flex left average class="suggest-bottom">
            <tk-flex center column>
              <div class="note">优化后开发费用</div>
              <div class="num">{{s.price + '元'}}</div>
            </tk-flex>
            <tk-flex center column>
              <div class="note">优化后开发周期</div>
              <div class="num">{{s.time + '天'}}</div>
            </tk-flex>
          </tk-flex>
        </div>
      </div>
    </tk-flex>
    <!--开发成果-->
    <tk-flex column center class="results no-print stripe-background">
      <div class="block-title">开发成果</div>
      <div class="result-box" :class="{center: resultData.length === 1}">
        <tk-flex
          center
          class="result-item"
          :class="{ 'tk-grid-4': device === 'desktop' }"
          v-for="(item, index) in resultData"
          :key="index"
        >
          <tk-icon>{{item.icon}}</tk-icon>
          {{item.text}}
        </tk-flex>
      </div>
      <tk-flex
        class="backend full-width"
        v-if="isInclude('result', 'backend')"
      >
        <template v-if="this.device === 'mobile'">
          <div>
            <div class="backend-title">为项目定制的数据管理后台</div>
            <p>采用国内最新的阿里巴巴开发的后台框架ant-design定制而成</p>
          </div>
          <tk-image
            height="114"
            src="http://moke-store.oss-cn-beijing.aliyuncs.com/ee09419b-1dd7-44b8-aeb3-b7030a6dff0a.png" />
        </template>
        <template v-else>
          <tk-image
            height="114"
            width="183"
            style="width: 183px;"
            src="http://moke-store.oss-cn-beijing.aliyuncs.com/ee09419b-1dd7-44b8-aeb3-b7030a6dff0a.png" />
          <div class="m-l-24">
            <div class="backend-title backend-title-pc">为项目定制的数据管理后台</div>
            <div class="m-t-24 backend-text-pc">采用国内最新的阿里巴巴开发的后台框架ant-design定制而成</div>
          </div>
        </template>
      </tk-flex>
    </tk-flex>
    <!--打印开发成果-->
    <div class="results not-show">
      <div class="title-td">开发成果</div>
      <div class="result-box" :class="{center: resultData.length === 1}">
        <div
          class="result-item"
          v-for="(item, index) in resultData"
          :key="index"
        >
          <tk-icon>{{item.icon}}</tk-icon>
          {{item.text}}
        </div>
      </div>
    </div>
    <!--赠送服务-->
    <tk-flex column center class="service no-print">
      <div class="block-title">赠送服务</div>
      <tk-flex wrap gutter="8" class="service-box full-width">
        <tk-flex column center class="service-item tk-grid-4" v-for="item in serviceData" :key="item.key">
          <tk-icon color="#465BE2">{{item.icon}}</tk-icon>
          {{item.text}}
        </tk-flex>
      </tk-flex>
      <tk-flex
        class="ali-server"
        column
        :style="{ backgroundImage: `url(${device === 'mobile' ? imageUrls.serviceBtnMobile : imageUrls.serviceBtnPc}) !important`,
         height: device === 'mobile' ? 159 : 280 + 'px' }"
        v-if="isInclude('service', 'server')"
      >
        <div v-if="device === 'mobile'">
          <div class="server-title">免费提供两年阿里云</div>
          <div class="server-title">服务器及运维</div>
        </div>
        <div v-else>
          <div class="server-pc-title">免费提供两年阿里云服务器及运维</div>
        </div>
        <div
          class="server-text m-t-12"
          :style="{ fontSize: device === 'mobile' ? 14 + 'px' : 20 + 'px',
          marginTop: device === 'mobile' ? 12 + 'px' : 32 + 'px' }"
        >
          可节省企业约<span class="text-strong">40000元</span>支出
        </div>
        <div
          :class="{ 'server-btn': device === 'mobile', 'server-pc-btn': device === 'desktop' }"
          @click="$push({ path: '/quotation/server', query: { id: id }})"
        >
          查看具体免费政策
        </div>
      </tk-flex>
      <div
        class="m-t-15
         service-sale"
        :style="{ height: device === 'mobile' ? 159 + 'px' : 280 + 'px' }"
      >
        <img
          class="sale-image"
          :style="{ height: device === 'mobile' ? 159 + 'px' : 280 + 'px' }"
          :height="device === 'mobile' ? 159 : 280"
          :src="device === 'mobile' ? imageUrls.servicePromoteMobile : imageUrls.servicePromotePc"
        />
      </div>
    </tk-flex>
    <!--打印其他赠送服务-->
    <div class="service not-show">
      <div class="title-td">其他赠送服务</div>
      <div class="service-box">
        <div
          class="service-item"
          v-for="item in serviceData"
          :key="item.key">
          <tk-icon color="#00009F" :size="30">{{item.icon}}</tk-icon>
          {{item.text}}
        </div>
      </div>
      <div
        class="ali-server"
        v-if="isInclude('service', 'server')"
      >
        <div class="ali-server-box">
          <tk-icon :size="28" color="#00009F">design</tk-icon>
          <div class="server-title">服务器及运维（免费提供两年阿里云）</div>
        </div>
        <div class="server-text">可节省企业约<span class="text-strong">40000元</span>支出</div>
      </div>
    </div>
    <!--开发团队对比-->
    <tk-flex
      center
      column
      class="team-contrast p-x-15 no-print"
    >
      <div class="block-title">开发团队</div>
      <div
        class="top-box p-x-24 p-t-20"
      >
        <div class="box-title">普通开发公司</div>
        <tk-flex
          :gutter="12"
          class="full-width m-t-16"
        >
          <tk-flex
            column
            class="tk-grid-2"
            v-for="(s, index) in ordinaryWorkers"
            :key="`top-box${index}`"
          >
            <tk-avatar :size="43">
              <tk-image :src="s.img" :width="43" :height="43"></tk-image>
            </tk-avatar>
            <div class="m-t-8 font-10 title-name">{{s.name}}</div>
          </tk-flex>
        </tk-flex>
        <div
          class="bottom-box"
        >
          <div class="box-title">默客科技</div>
          <tk-flex
            class="m-t-16"
          >
            <tk-flex
              column
              class="tk-grid-2"
              v-for="(s, index) in workers"
              :key="`top-box${index}`"
            >
              <tk-avatar :size="43" :class="{ 'css-filter': !s.isClick }">
                <tk-image :src="s.img" :width="43" :height="43"></tk-image>
              </tk-avatar>
              <div
                class="font-10 title-name"
                v-html="s.name"
              ></div>
              <div class="triangle-up" v-if="s.isClick"></div>
            </tk-flex>
          </tk-flex>
          <div class="box-tip" v-if="tooltip">{{tooltip.tooltip}}</div>
        </div>
      </div>
    </tk-flex>
    <!--开发周期-->
    <tk-flex
      center
      column
      class="price stripe-background no-print"
      v-if="data.price && data.duration"
    >
      <div class="block-title">开发费用和周期</div>
      <div class="price-body">
        <div>
          <span>开发费用：</span>
          <span class="red-text">
              {{data.price}} 万元
            </span>
        </div>
        <div>
          <span>开发周期：</span>
          <span class="red-text">
              {{data.duration}} 天
            </span>
        </div>
      </div>
    </tk-flex>
    <!--打印开发周期-->
    <div
      class="price not-show"
      v-if="data.price && data.duration"
    >
      <div class="title-td">开发费用和周期</div>
      <div class="price-body stripe-background">
        <div>
          <span>开发费用：</span>
          <span class="red-text">
              {{data.price}} 万元
            </span>
        </div>
        <div>
          <span>开发周期：</span>
          <span class="red-text">
              {{data.duration}} 天
            </span>
        </div>
      </div>
    </div>
    <!--成功案例-->
    <tk-flex
      center
      column
      v-if="cases.length"
      class="success-cases full-width"
    >
      <div class="block-title">成功案例</div>
      <tk-flex wrap class="full-width">
        <tk-flex
          center
          middle
          column
          class="tk-grid-4"
          v-for="(s, index) in cases"
          :key="`success-cases${index}`"
          :class="{ 'm-t-15': index > 2 }"
        >
          <tk-image :src="s.QRcode" :width="105" :height="105"></tk-image>
          <div class="cases-btn">{{s.text}}</div>
        </tk-flex>
      </tk-flex>
    </tk-flex>
    <!--关心的问题-->
    <tk-flex center column class="no-print">
      <div class="block-title">您可能关心的问题</div>
      <qa-problem :qa="qa"></qa-problem>
    </tk-flex>
    <div class="description">
      <div>备注说明：</div>
      <ol class="m-t-10">
        <li>应用商店上架：因缺少相关资质，或违反相关法律规定而无法上架的app不在服务范围。</li>
        <li>开发周期：开发周期指自然日，设计时间不计算在内。</li>
        <li>开发费用：不包含第三方服务或其他非开发范围内的费用，例如：短信验证码，实名认证，微信认证等等。</li>
      </ol>
    </div>
    <!--底部描述-->
    <div class="footer no-print">
      <tk-flex middle between>
        <tk-flex class="logo" middle>
          <tk-image height="35" src="http://moke-store.oss-cn-beijing.aliyuncs.com/a113431e-9efd-47c5-9168-1596a1a7901c.png"/>
        </tk-flex>
        <div class="m-r-5">
          <tk-qrcode :value="qrValue"></tk-qrcode>
          <div class="qr-des">扫码分享</div>
        </div>
      </tk-flex>
    </div>
    <div class="copyright no-print">
      Copyright © 2011-2020 默客科技版权所有
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import qaProblem from '@/components/commonProblem'
import loading from '@/components/loading'
import { QA, works, cases, imageUrl } from '@/assets/js/qa'
document.oncontextmenu = function () { return false }

export default {
  name: 'home',
  components: {
    qaProblem,
    loading
  },
  data () {
    return {
      data: null,
      complete: true,
      printStatus: false,
      imageUrls: imageUrl,
      qa: QA,
      resultList: [{
        key: 'ios',
        icon: 'ios',
        text: 'IOS端APP'
      }, {
        key: 'android',
        icon: 'android',
        text: '安卓端app'
      }, {
        key: 'wechat',
        icon: 'WeChat',
        text: '微信公众号'
      }, {
        key: 'h5',
        icon: 'h5',
        text: 'h5网站'
      }, {
        key: 'mp',
        icon: 'applets',
        text: '微信小程序'
      }],
      serviceList: [{
        key: 'appStore',
        icon: 'mall',
        text: '上架应用商店'
      }, {
        key: 'product',
        icon: 'suggest',
        text: '产品策划建议'
      }, {
        key: 'ui',
        icon: 'design',
        text: 'UI产品设计'
      }, {
        key: 'logo',
        icon: 'logo',
        text: 'LOGO设计'
      }, {
        key: 'maintain',
        icon: 'maintain',
        text: '后期应用维护'
      }, {
        key: 'copyright',
        icon: 'geruanjianzhuzuoquan',
        text: '软件著作权'
      }, {
        key: 'personnel',
        icon: 'personnel',
        text: '专业运维人员'
      }],
      workers: works,
      cases: cases
    }
  },
  apollo: {
    $subscribe: {
      data: {
        query: gql`subscription quotationSubscription($id: Int!) {
          quotation_by_pk (id: $id) {
            id
            title
            modules
            price
            duration
            result
            suggest
            service
            updated_at
          }
        }`,
        result (res, key) {
          this.data = res.data.quotation_by_pk
          let title = res.data && res.data.quotation_by_pk && res.data.quotation_by_pk.title ? res.data.quotation_by_pk.title : ''
          if (title) {
            document.title = '默客科技-' + title
          }
        },
        variables () {
          return {
            id: Number(this.id)
          }
        }
      }
    }
  },
  mounted () {
    if (this.isPdf) {
      document.querySelector('#app').style.cssText = 'background: white;'
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    qrValue () {
      return `http://wechat.mokekeji.com/quotation/${this.id}`
    },
    resultData () {
      return this.data && this.data.result ? this.resultList.filter(r => this.data.result.includes(r.key)) : []
    },
    serviceData () {
      return this.data && this.data.service ? this.serviceList.filter(r => this.data.service.includes(r.key)) : []
    },
    ordinaryWorkers () {
      let arr = Object.assign(this.workers)
      return arr.filter(s => { return s.name === '工程师' || s.name === '设计师' })
    },
    tooltip () {
      return this.workers.find(s => { return s.isClick === true })
    },
    isPdf () {
      return this.$route.query.pdf
    }
  },
  beforeDestroy () {
    if (this.setTimer) { clearInterval(this.setTimer) }
  },
  activated () {
    this.getInit()
  },
  methods: {
    isInclude (type, key) {
      if (!this.data) return false
      return this.data[type].findIndex(k => k === key) > -1
    },
    /**
    * 打印
    * @date: 2020/11/2
    */
    printPlan () {
      this.$el.classList.add('print-body')
      window.print()
    },
    exportPdf () {
      let url = `https://url-to-pdf.mokekeji.com/api/render?waitFor=1000&attachmentName=${this.data.title}.pdf&url=https://wechat.mokekeji.com/quotation/${this.id}?pdf=true`
      window.open(url)
    },
    /**
    * 定时提示
    * @date: 2020/10/21
    */
    getInit () {
      this.complete = true
      let index = 0
      if (this.setTimer) { clearInterval(this.setTimer) }
      this.setTimer = setInterval(() => {
        index++
        if (index >= this.workers.length) {
          index = 0
        }
        this.workers.forEach(m => { m.isClick = false })
        this.workers[index].isClick = true
      }, 3000)
      setTimeout(() => { this.complete = false }, 1500)
    },
    /**
    * 选择职工
    * @date: 2020/10/21
    */
    selectedWork (s, index) {
      if (this.setTimer) { clearInterval(this.setTimer) }
      this.workers.forEach(m => { m.isClick = false })
      this.workers[index].isClick = true
      this.$forceUpdate()
      setTimeout(() => {
        this.workers.forEach(m => { m.isClick = false })
        this.workers[0].isClick = true
        this.getInit()
      }, 3000)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../assets/scss/_idScss.scss';
  /*打印样式*/
  @page {
    text-align: center;
    margin: 3mm 8mm 3mm 8mm;
    .print-body {
      page-break-inside: avoid;
    }
  }
  @media print {
    .not-show {
      display: block;
    }
    .no-print{
      display: none;
    }
    .quotation-body {
      width: 100% !important;
      height: 100%;
      margin: 0 auto;
    }
    .print-body {
      page-break-inside: avoid;
    }
    .print-body .block-title {
      border-bottom: 0 !important;
      margin-top: 30px !important;
      margin-bottom: 16px !important;
    }
    .print-body .body-title {
      font-weight: bold !important;
      font-size: 21px !important;
      color: #0a0a0a !important;
      padding-top: 63px !important;
      margin: 0 !important;
      text-align: center !important;
    }
    .print-body .stripe-background {
      -webkit-print-color-adjust: exact;
      background: linear-gradient(#F8F4F9 50%, transparent 50%);
      background-size: 100% 6px;
    }
    .print-body .author {
      margin: 0 !important;
    }
    .print-body .body-date {
      font-size: 12px !important;
      color: #333333 !important;
      margin-bottom: 16px !important;
      text-align: center;
    }
    .title-td {
      font-weight: bold !important;
      font-size: 15px !important;
      color: #212121 !important;
      margin-top: 30px !important;
      margin-bottom: 16px !important;
    }
    .print-body .module-box {
      position: relative;
      text-align: inherit !important;
    }
    .print-body .module-box table {
      width: 100%;
      border-left: 1px solid #B3B3B3;
      border-right: 1px solid #B3B3B3;
    }
    .print-body .module-box table tr {
      transform: scale(1);
    }
    .print-body .module-box table tr:hover .module-row-action {
      display: block;
    }
    .print-body .module-box table .td-tr-title {
      height: 53px;
      font-size: 12px !important;
      font-weight: normal !important;
      background-color: #00009f !important;
      -webkit-print-color-adjust: exact;
      color: #ffffff;
    }
    .print-body .module-box table th,
    .print-body .module-box table td {
      text-align: left;
      padding: 0 15px;
      height: 0 !important;
      background-color: transparent !important;
      font-weight: normal !important;
    }
    .print-body .module-box table td {
      padding: 15px;
      font-size: 12px !important;
      border-bottom: 1px solid #B3B3B3;
    }
    .print-body .module-box table td:first-child {
      border-right: 1px solid #B3B3B3;
    }
    .print-body .module-box table th:first-child,
    .print-body .module-box table td:first-child {
      width: 30%;
    }
    .print-body .results {
      padding: 0 15px !important;
    }
    .print-body .results .result-box {
      background-color: rgba(239, 239, 239, 1);
      -webkit-print-color-adjust: exact;
      border-radius: 8px;
      width: 100%;
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 23px;
      box-sizing: border-box;
      display: inline-flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }
    .print-body .results .result-box.center {
      /*text-align: center;*/
    }
    .print-body .results .result-box .result-item {
      display: inline-flex;
      padding-top: 23px;
      font-weight: bold;
      height: 94px;
      align-items: center;
      font-size: 16px;
      width: 33.33%;
      color: #141414;
    }
    .print-body .results .result-box .result-item svg {
      margin-right: 10px;
      width: 30px;
      height: 30px;
    }
    .print-body .results .backend {
      margin: 20px 0;
    }
    .print-body .results .backend > * {
      width: 50%;
    }
    .print-body .results .backend .backend-title {
      font-size: 18px;
      color: rgba(45, 45, 73, 1);
      font-weight: bolder;
      margin-bottom: 5px;
    }
    .print-body .results .backend p {
      font-size: 10px;
      color: #7c7c99;
    }
    .print-body .service .service-box {
      display: flex;
      flex-wrap: wrap;
      margin: -16px 0 0 -16px;
    }
    .print-body .service  .service-box .service-item {
      font-size: 15px;
      color: #141414;
      min-height: 103px;
      border-radius: 5px;
      -webkit-print-color-adjust: exact;
      background-color: #efefef;
      font-weight: 400;
      width: calc(33.33% - 16px);
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 16px 0 0 16px;
    }
    .print-body .service .service-item svg {
      margin: 16px 0 16px 0;
      flex-shrink: 0;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      fill: #00009f !important;
    }
    .print-body .service .ali-server {
      width: 100%;
      margin-top: 31px;
      min-height: 132px;
      -webkit-print-color-adjust: exact;
      background-color: #efefef;
      padding: 36px;
      border-radius: 8px;
    }
    .print-body .service .ali-server .ali-server-box {
      display: flex;
      justify-items: center;
    }
    .print-body .service .ali-server .server-title {
      font-size: 20px;
      color: #141414;
      margin-left: 22px;
    }
    .print-body .service .ali-server svg {
      -webkit-print-color-adjust: exact;
      flex-shrink: 0;
      fill: #00009F;
    }
    .print-body .service .ali-server .server-text {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      margin-top: 14px;
    }
    .print-body .service .ali-server .server-text .text-strong {
      color: #F54F3D;
    }
    .print-body .price {
      margin-top: 0 !important;
      padding: 0 15px !important;
    }
    .print-body .price .price-body {
      width: 100%;
      font-size: 16px !important;
      color: #242424;
      padding: 63px 15px !important;
      display: flex;
      justify-content: space-around;
    }
    .print-body .price .price-body > div {
      font-weight: bolder;
      line-height: 32px;
      color: #2d2d49;
    }
    .print-body .price .price-body .red-text {
      font-size: 16px;
      color: #f34a4f !important;
    }
    .print-body .description {
      padding: 0 15px !important;
      font-size: 12px !important;
      color: #666666 !important;
      margin-top: 26px !important;
      font-style: italic !important;
    }
    .print-body .description li {
      margin-left: 12px;
      list-style: decimal !important;
      line-height: 22px !important;
    }
  }
  .pdf {
    .header {
      display: none;
    }
    width: 100%;
  }
</style>
